/**
 * Convert device name to include registered trademark HTML
 * @param {string} device - Device name (case-insensitive for proper/lowercase, may already contain trademark HTML)
 * @param {string} bool - Whether to add trademark ('false' to skip, any other string to add)
 * @returns {string} Device name with or without trademark HTML
 */
export default function addRegToDevice(device, bool) {
  if (bool === 'false') return device;

  const TRADEMARK = '<sup>&reg;</sup>';

  // Map of devices with specific formatting
  const deviceMap = {
    'Nucleus 9': `Nucleus${TRADEMARK}&nbsp;9`,
    'Nucleus 8': `Nucleus${TRADEMARK}&nbsp;8`,
    'Nucleus 7': `Nucleus${TRADEMARK}&nbsp;7`,
    'Nucleus 6': `Nucleus${TRADEMARK}&nbsp;6`,
    'Nucleus 5': `Nucleus${TRADEMARK}&nbsp;5`,
    'Kanso 4': `Kanso${TRADEMARK}&nbsp;4`,
    'Kanso 3': `Kanso${TRADEMARK}&nbsp;3`,
    'Kanso 2': `Kanso${TRADEMARK}&nbsp;2`,
    'Baha 8': `Baha${TRADEMARK}&nbsp;8`,
    'Baha 7': `Baha${TRADEMARK}&nbsp;7`,
    'Baha 6 Max': `Baha${TRADEMARK}&nbsp;6 Max`,
    'Baha 5': `Baha${TRADEMARK}&nbsp;5`,
    'Baha 5 Power': `Baha${TRADEMARK}&nbsp;5 Power`,
    'Baha 5 SuperPower': `Baha${TRADEMARK}&nbsp;5 SuperPower`,
    'Baha 4': `Baha${TRADEMARK}&nbsp;4`,
    'Osia 3': `Osia${TRADEMARK}&nbsp;3`,
    'Osia 2': `Osia${TRADEMARK}&nbsp;2`,
  };

  // Check exact match first
  if (deviceMap[device]) {
    return deviceMap[device];
  }

  // Check case-insensitive match only for proper case and lowercase variations
  const lowerDevice = device.toLowerCase();
  const matchingKey = Object.keys(deviceMap).find(
    (key) => key.toLowerCase() === lowerDevice,
  );
  if (matchingKey) {
    return deviceMap[matchingKey];
  }

  // Return brand-only trademark for known brands
  if (
    ['Nucleus', 'Baha', 'Kanso', 'Freedom', 'Osia'].includes(device)
  ) {
    return `${device}${TRADEMARK}`;
  }

  // Check case-insensitive for brands
  const lowerBrand = device.toLowerCase();
  if (
    ['nucleus', 'baha', 'kanso', 'freedom', 'osia'].includes(
      lowerBrand,
    )
  ) {
    return `${device}${TRADEMARK}`;
  }

  return device;
}
